import { render } from "./Select2Array.vue?vue&type=template&id=8a2f8290"
import script from "./Select2Array.vue?vue&type=script&lang=js"
export * from "./Select2Array.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__